export default "__VITE_ASSET__Ck05HHGo__"